import SocialMediaIcon from 'components/SocialMediaIcon/SocialMediaIcon'
import React from 'react'

export default function SocialMediaRadio({
  platform,
  text,
}: {
  platform: string
  text: string
}): JSX.Element {
  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <SocialMediaIcon platformName={platform} width={22} />
      <span style={{ fontSize: '20px' }}>{text}</span>
    </div>
  )
}
